import { Component, ViewEncapsulation, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-subscription-banner-feedback',
  templateUrl: './subscription-banner-feedback.component.html',
  styleUrls: ['./subscription-banner-feedback.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SubscriptionBannerFeedbackComponent {

  public dialogRef = inject(MatDialogRef<SubscriptionBannerFeedbackComponent>);

  

  // @Todo implement logic
  leaveFeedback(): void {
  }
}
